<template>
    <div style='width: 100%; height:100%;'>
        <el-card>
            <div slot='header'>
                <el-button
                    v-for="(item, index) in typeList"
                    :key="item"
                    :type='item === isSelect ? "primary": "" '
                    @click="selectType(index)"
                    class="topButton">
                        {{tableVal(item,env)}}
                </el-button>
            </div>

            <div class="messageBox">
                <div>
                    <div class="leftTop">
                        <span
                            v-for='(item, index) of titleBtns'
                            :key='item.index'
                            @click='changeComponent(index)'
                            :class='item.index === indexName ? "active" : ""'>
                                <img :src="item.imgUrl" alt="" srcset="">
                                {{item.title}}
                        </span>
                    </div>

                    <div class="leftCenter">
                        <div>
                            <img src="../../../../assets/health-80plus.png" alt="" srcset="">
                            <span @click='routerHistory'>
                                构建历史
                            </span>
                        </div>

                        <div>
                            <el-button @click='showUp' v-if='showFlag' type='text' class='el-icon-minus'></el-button>
                            <el-button @click='showUp' v-if='!showFlag' type='text' class='el-icon-plus'></el-button>
                        </div>
                    </div>

                    <div class="leftSearch">
                        <el-input v-model="searchVal" @keyup.enter.native="getDetailList"></el-input>
                    </div>

                    <div class="historyList">
                        <div class="detailList" v-for='item in detailList' :key='item.id'>
                            <div class='detailListTitle' @click='detailLog(item.id)'>
                                    <img :src="item.icon_colour" alt="" @click.stop='routerLog(item.id)'>
                                <span>ID:{{item.id}} 发布人:{{item.user_cn_name}}</span>
                            </div>
                            <div v-if='item.progress<100'>
                                <el-progress :percentage="item.progress"></el-progress>
                            </div>
                            <div class='detailListCen'>
                                <p><span>{{item.start_time}}</span></p>
                                <p><span>环境:</span><span>{{ tableVal(item.env,env)}}</span></p>
                                <p><span>分支:</span>{{item.branch}}<span></span></p>
                                <p><span>部署机器:</span><span>{{item.target_value.join(',')}}</span></p>
                                <p><span>生成tag:</span><span>{{item.tag}}</span></p>
                                <p><span>sonar地址:</span><span>{{item.sonar_url}}</span></p>
                            </div>
                        </div>
                    </div>

                </div>

                <div>
                     <router-view></router-view>
                </div>
            </div>

        </el-card>
    </div>
</template>

<script>
    import services from '../../cicd.services'

    import { imgMessage } from '../../cicd.config'
    import { clearTimeout } from 'timers';
    const imgList = imgMessage()

    export default {

        data() {
            return {
                typeList: [],
                index: 0,
                detailList: [],
                titleBtns: [
                    { index: 'ParamsBuild', title: '参数构建', imgUrl: require('../../../../assets/param.png') },
                    { index: 'PrevBuild', title: '上次构建', imgUrl: require('../../../../assets/prevIcon.png') },
                ],
                indexName: '',
                searchVal: '',
                imgList,
                timer: null,
                showFlag: true
            }
        },

        watch: {
            typeList() {
                this.getDetailList()
            },
            showFlag(newVal) {
                if (newVal) {
                    this.getDetailList()
                } else {
                    clearInterval(this.timer)
                    this.detailList = []
                }
            }
        },

        computed: {
            isSelect() {
                return this.typeList[this.index]
            },
            dictionary() {
                return this.$store.state.dictionary2
            },
            env() {
                return this.dictionary.env
            },
            params() {
                return this.$route.params
            },
            parentId() {
                return this.params.id
            },
            type() {
                return this.params.type
            }
        },

        created() {
            this.getDetail()
        },

        mounted() {
            clearInterval(this.timer)
            this.timer = setInterval(() => {
                this.getDetailList()
            }, 5000)
        },

        methods:{
            // 收起站展开
            showUp() {
                this.showFlag = !this.showFlag
            },


            // 跳转至历史信息
            routerHistory() {
                this.$router.push({
                    name: "IntegrationHome",
                    params: {
                        id: this.$route.params.id,
                        env: this.isSelect | this.typeList[0]
                    }
                })
            },

            // 跳转至日志
            routerLog(id) {
                this.$router.push({
                    name: "BuildLog",
                    params: {
                        id: this.$route.params.id,
                        selfId: id,
                        envId: this.isSelect
                    }
                })
            },

            // 获取图片路径
            getImgUrl(val) {
                let arr = this.imgList.filter(item => item.id === val)
                return arr[0].name
            },

            // 搜索请求事件
            getDetailList() {
                this.showFlag = true
                let params = {
                    id: this.parentId,
                    env: this.isSelect,
                    keyword: this.searchVal
                }
                if (this.searchVal.trim()) {
                    services.searchBuildHistory(params)
                        .then(res => this.detailList = res.list.map(item => ({ ...item, icon_colour: this.getImgUrl(item.icon_colour) })))
                        .catch(err => this.$message.error(err.message))
                } else {
                    services.buildHistory(params)
                        .then(res => this.detailList = res.list.map(item => ({ ...item, icon_colour: this.getImgUrl(item.icon_colour) })))
                        .catch(err => this.$message.error(err.message))
                }
            },

            // 跳转到构建详情页面
            detailLog(ind) {
                this.$router.push({
                    name: 'BuildDetail',
                    params: {
                        id: this.parentId,
                        env: this.isSelect,
                        selfId: ind
                    }
                })
            },

            // 获取详情
            getDetail() {
                services.nodeInfo({ appId: this.parentId })
                    .then(res => {
                        this.typeList = res.env
                        if (this.type !== 'router') {
                            this.routerHistory()
                        }
                    })
                    .catch(err => this.$message.error(err.message))
            },

            // 切换页面
            changeComponent(index) {
                this.indexName = this.titleBtns[index].index
                this.$router.push({
                    name: this.titleBtns[index].index,
                    params: {
                        ...this.params,
                        env: this.isSelect
                    }
                })
            },

            //选择环境
            selectType(index){
                this.index = index
                this.$router.push({
                    name: 'Integration',
                    params: {
                        ...this.params,
                        env: this.isSelect
                    }
                })
                this.getDetailList()
                this.routerHistory()
            }
        },
        // 根据数据字典取值
        tableVal(value, arr) {
            if(!arr) return '无'
            if(arr && arr.length == 0) return "无"
            let res = arr.filter(item => item.default == value)
            let str = ""
            if(!res.length) str =  "无"
            str = res[0].cname
            return str
        },

        destroyed() {
            clearInterval(this.timer)
        }
    }
</script>

<style rel="stylesheet/scss" lang="scss" scoped>
    .messageBox{
        display: flex;
        &>div:nth-child(1){
            width: 300px;
            margin-right: 20px;
        };
        &>div:nth-child(2) {
            width: calc(100% - 300px);
            height: 100%;
        }
    }
    .leftTop{
        width: 100%;
        padding-left: 0px;
        display: flex;
        flex-direction: column;
        padding: 0 20px;
        &>span{
            img {
                vertical-align: middle;
            }
            padding: 15px 0px;
            cursor: pointer;
            border-bottom: 1px solid #ccc;
            &:last-of-type {
                border-bottom: none;
            }
        }
        .active {
            background: #eee;
        }
    }
    .leftCenter {
        width: 100%;
        margin: 10px 0;
        padding: 10px;
        font-weight: 800;
        background: #eee;
        display:flex;
        align-items: center;
        justify-content: space-between;
        img {
            width: 20px;
            height: 20px;
            vertical-align: middle;
            margin-right: 05px;
        }
        span {
            cursor: pointer;
        }
    }
    .historyList{
        // height: 580px;
        overflow: scroll;
        margin-top: 10px;
        .detailList:nth-of-type(2n-2) {
            background: #fbfbfb;
        }
        .detailList{
            padding: 10px 0;
            .detailListTitle {
                font-weight: 800;
                cursor: pointer;
                img {
                    width: 20px;
                    height: 20px;
                    vertical-align: middle;
                }
            }
            .detailListCen {
                padding-left: 10px;
                p {
                    border-left: 1px solid #ccc;
                    padding-left: 10px;
                }

            }
        }
    }
</style>
